module.exports = __webpack_public_path__ + "03c20243a2f8082383e0672698894aa1.svg";